var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3646 13.671C10.2304 14.3571 8.89643 14.7526 7.46894 14.7526C3.34396 14.7526 0 11.4501 0 7.37629C0 3.30248 3.34396 0 7.46894 0C11.5939 0 14.9379 3.30248 14.9379 7.37629C14.9379 9.40279 14.1104 11.2384 12.771 12.5716L16.7375 16.4889C17.0875 16.8346 17.0875 17.3951 16.7375 17.7407C16.3875 18.0864 15.82 18.0864 15.47 17.7407L11.4561 13.7767C11.4224 13.7434 11.3918 13.708 11.3646 13.671ZM13.1453 7.37629C13.1453 10.4724 10.6039 12.9823 7.46894 12.9823C4.33396 12.9823 1.79255 10.4724 1.79255 7.37629C1.79255 4.28019 4.33396 1.77031 7.46894 1.77031C10.6039 1.77031 13.1453 4.28019 13.1453 7.37629Z",
    fill: "#0D1536",
    fillOpacity: 0.65
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.da2358a0c98a2b291f9e6c158babee22.svg";
export { ForwardRef as ReactComponent };